// export interface PackageOrder {
//   packageId: number;
//   name: string;
//   price: number;
//   teamBonusPercent: number | null;
//   order: number;
//   stakeRatio: number;
//   weekCapRuleLimit: number | null;
//   volumePoints: number | null;
// }

export interface UserMemberhsip {
  id: number;
  currencyType: number;
  dateCreated: string;
  datePaid: string | null;
  dateStart: string | null;
  dateEnd: string | null;
  isCancelable: boolean;
  isCurrent: boolean;
  orderType: number;
  status: number;
  user: User;
}

interface User {
  id: number;
  name: string;
  surname: string;
  profileImageUrl: string;
  email: string;
  dateCreated: string;
}

export enum PackageStatus {
  PENDING = 1,
  PAID,
  CANCELED,
  CANCELED_BY_USER
}

// export enum CalculationStatus {
//   CALCULATE = 1,
//   SKIP_WITH_HUB_CREATION = 6
// }

export enum CalculationStatus {
  CALCULATE = 1,
  SKIP_WITH_HUB_CREATION,
  SKIP_WITHOUT_HUB_CREATION,
  SKIP_WITH_HUB_CREATION_ADD_PO_PV,
  SKIP_WITHOUT_HUB_CREATION_ADD_PO_PV,

  SKIP_WITH_HUB_CREATION_ADD_PO,
  SKIP_WITHOUT_HUB_CREATION_ADD_PO,
  SKIP_WITH_HUB_CREATION_ADD_PV,
  SKIP_WITHOUT_HUB_CREATION_ADD_PV,
  LP_TRADING_ADD_PO
}

export enum OpenedModal {
  CLOSED,
  RECALCULATE_TOTAL_BONUS,

  MARK_AS_PAID,
  MARK_AS_PAID_WITH_HUB_NO_CALCULATION_NO_POPV,
  MARK_AS_PAID_NO_HUB_NO_CALCULATION_NO_POPV,
  MARK_AS_PAID_WITH_HUB_NO_CALC_WITH_POPV,
  MARK_AS_PAID_NO_HUB_NO_CALC_WITH_POPV,

  MARK_AS_PAID_WITH_HUB_NO_CALCULATION_WITH_PO,
  MARK_AS_PAID_NO_HUB_NO_CALCULATION_WITH_PO,
  MARK_AS_PAID_WITH_HUB_NO_CALCULATION_WITH_PV,
  MARK_AS_PAID_NO_HUB_NO_CALCULATION_WITH_PV,
  LP_TRADING_ADD_PO,

  STORNO,
  RESEND_PAYMENT_INSTRUCTIONS
}

export enum OrderType {
  ORDER = 1,
  PACKAGE,
  LICENCE,
  COMBO
}

export enum CurrencyType {
  BANK_TRANSFER = 1,
  SHOPPING_POINTS,
  REWARD_POINTS,
  LOYALTY_POINTS,
  MIX,
  USDC = 7
}
